import React from 'react'
import AvatarStats from '../../components/avatarstats/AvatarStats'


import './avatarpage.css'

const AvatarPage = () => {
  return (
    <div className='avatarpage'>
      <AvatarStats />
    </div>
  )
}

export default AvatarPage
